import * as M from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useGetManualHistory } from '../../../../../../shared/apis/ai-agent/manual/reactQueries';
import * as C from '../../../../../ui/common/CommonStyles';

import useAiAgentManualHistoryFilters from './hooks/useAiAgentManualHistoryFilters';
import AiAgentManualFilterSection from './ui/filterSection';
import ManualHistoryTable from './ui/manualHistoryTable';
import { buildSearchString } from '../../utils/buildSearchString';

export default function AiAgentManualHistory() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';
  const manualName = searchParams.get('manualName') || '';
  const { companyId, fileUploadId } = useParams<{ companyId: string; fileUploadId: string }>();
  const {
    filterForm,
    queryParams,
    searchType,
    inputRef,
    handlePageChange,
    updateFilterForm,
    handleSearchType,
    handleSearch,
    resetSearchInput,
    resetFilters,
  } = useAiAgentManualHistoryFilters(Number(companyId), Number(fileUploadId));

  const { data: manualHistory, isLoading, isError } = useGetManualHistory(queryParams);

  return (
    <M.Box>
      <C.TitleBox>
        <div className="title">매뉴얼 설정 이력</div>
      </C.TitleBox>
      <C.ListBox style={{ overflowX: 'visible' }}>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Flex gap="md">
              <M.Box>
                <M.Text size="xs" c="gray.6">
                  거래처명
                </M.Text>
                <M.Text fw={500}>{companyName}</M.Text>
              </M.Box>
              <M.Box>
                <M.Text size="xs" c="gray.6">
                  매뉴얼명
                </M.Text>
                <M.Text fw={500}>{manualName}</M.Text>
              </M.Box>
            </M.Flex>

            <M.Button
              variant="default"
              size="xs"
              leftSection={<IconChevronLeft size={14} />}
              onClick={() =>
                navigate(
                  `/admin/management/aiagent/company/${companyId}/manual${buildSearchString({
                    companyName,
                  })}`,
                  { replace: true },
                )
              }
            >
              목록으로
            </M.Button>
          </M.Flex>
          <AiAgentManualFilterSection
            filterForm={filterForm}
            searchType={searchType}
            inputRef={inputRef}
            onChangeFilterForm={updateFilterForm}
            onChangeSearchType={handleSearchType}
            handleSearch={handleSearch}
            resetSearchInput={resetSearchInput}
            onReset={resetFilters}
          />
          <ManualHistoryTable
            history={manualHistory}
            page={queryParams.page}
            size={queryParams.size}
            isLoading={isLoading}
            isError={isError}
            onPageChange={handlePageChange}
          />
        </M.Stack>
      </C.ListBox>
    </M.Box>
  );
}
